import Api from './api.service'

export default {
  create (object) {
    return Api().post('product/create', object)
  },
  get (id) {
    return Api().get('product/get/' + id)
  },
  update (object) {
    return Api().put('product/edit/' + object.id, object.object)
  },
  productList (filter) {
    return Api().get('product/get', { params: filter })
  },
  exportProductList (filter) {
    return Api().get('product/export', { params: filter })
  },
  productNameList (filter) {
    return Api().get('/product/list',  { params: filter })
  },
  getManufacturerList () {
    return Api().get('manufacturer/get')
  },
  getParameterList (filter) {
    return Api().get('productParameter/get', { params: filter })
  },
  getLineChart () {
    return Api().get('user/getLinechartInfo')
  },
  getManufacturNameList () {
    return Api().get('manufacturer/name')
  },
}